module.exports = __webpack_public_path__ + "static/11-jenny-e559e7a8ae89ca1b585a1e23eca4f3bd.jpg";